import gql from 'graphql-tag';

export const getPublicFacilities = gql`
  query getPublicFacilities {
    getPublicFacilities {
      id
      facilityUid
      facilityName
    }
  }
`;
